var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
const getConversionRequests = (name) => __awaiter(void 0, void 0, void 0, function* () {
    const [sbdConversions] = yield Promise.all([
        ConversionUtils.getSbdConversions(name),
        // ConversionUtils.getSteemConversions(name),
    ]);
    return [
        // ...steemConversions.map((conv: CollateralizedConversion) => ({
        //   amount: conv.collateral_amount,
        //   conversion_date: conv.conversion_date,
        //   id: conv.id,
        //   owner: conv.owner,
        //   requestid: conv.requestid,
        //   collaterized: true,
        // })),
        ...sbdConversions.map((conv) => (Object.assign(Object.assign({}, conv), { collaterized: false }))),
    ].sort((a, b) => new Date(a.conversion_date).getTime() -
        new Date(b.conversion_date).getTime());
});
const getSbdConversions = (username) => {
    return SteemTxUtils.getData('condenser_api.get_conversion_requests', [
        username,
    ]);
};
const getSteemConversions = (username) => {
    return SteemTxUtils.getData('condenser_api.get_collateralized_conversion_requests', [username]);
};
const convert = (username, conversions, amount, conversionType, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestId = Math.max(...conversions.map((e) => e.requestid), 0) + 1;
    return ConversionUtils.sendConvert(username, requestId, amount, conversionType, activeKey, options);
});
/* istanbul ignore next */
const sendConvert = (username, requestId, amount, conversionType, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemTxUtils.sendOperation([
        ConversionUtils.getConvertOperation(username, requestId, amount, conversionType),
    ], activeKey, false, options);
});
const getConvertOperation = (username, requestId, amount, conversionType) => {
    return ['convert', { owner: username, requestid: requestId, amount: amount }];
};
const getConvertTransaction = (username, requestId, amount, conversionType) => {
    return SteemTxUtils.createTransaction([
        ConversionUtils.getConvertOperation(username, requestId, amount, conversionType),
    ]);
};
export const ConversionUtils = {
    getConversionRequests,
    getSbdConversions,
    // getSteemConversions,
    getConvertOperation,
    sendConvert,
    convert,
    getConvertTransaction,
};
